import { render, staticRenderFns } from "./Classificacao.vue?vue&type=template&id=22fec7c4&scoped=true"
import script from "./Classificacao.vue?vue&type=script&lang=js"
export * from "./Classificacao.vue?vue&type=script&lang=js"
import style0 from "../../../css/crud.css?vue&type=style&index=0&id=22fec7c4&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fec7c4",
  null
  
)

export default component.exports